<script setup>
import { ref } from 'vue';
import { registro } from '@/utils/usuarioRedirections';


const props = defineProps({
    usuarioStore: Object
})

// const emit = defineEmits(["toggle-register"]);
const showPassword = ref(false);
const usuarioStore = props.usuarioStore;

function isRegister() {
    // emit("toggle-register");
    registro();
}

const iniciarSesion = async () => {
        await usuarioStore.iniciarSesion();

};
</script>


<template>
    <h3 class="text-soft-green mb-3">Subasta</h3>
    <h2 class="text-start mb-1">Ingresar</h2>
    <p class="text-start">
        ¿Aún no estás registrado? 
        <span @click="isRegister()" class="text-soft-green fs-16 cursor-pointer">Registrate</span>
    </p>

    <form @submit.prevent="iniciarSesion">
        <div class="mb-3">
            <label for="email" class="form-label text-black">Email</label>
            <input 
                type="email" 
                v-model="usuarioStore.user.email" 
                :class="['form-control', 'border-soft-grey', 'rounded-1', usuarioStore.loginError ? 'is-invalid border-danger' : '']"
                id="email"
            />
        </div>

        <div class="mb-3">
            <label for="password" class="form-label text-black">Contraseña</label>
            <div 
                :class="['input-soft-group', 'border-soft-grey', 'rounded-1', 'overflow-hidden', usuarioStore.loginError ? 'is-invalid border-danger' : '']"
            >
                <input 
                    :type="showPassword ? 'text' : 'password'" 
                    class="form-control border-0 shadow-none"
                    id="password" 
                    required 
                    v-model="usuarioStore.user.password"
                >
                <span class="input-group-text border-0" @click="showPassword = !showPassword" style="cursor:pointer;">
                    <i :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
                </span>
            </div>

            <!-- Mensaje de error -->
            <div v-if="usuarioStore.loginError" class="invalid-feedback d-block fs-13">
                {{ usuarioStore.loginError }}
            </div>

            <a href="#" class="d-block text-start mt-2 text-soft-green fs-13">¿Olvidaste tu contraseña?</a>
        </div>

        <button type="submit" class="btn btn-soft-green d-flex justify-content-center fw-bold mt-4" style="width: 140px;">
            Ingresar
        </button>
    </form>
</template>